<template>
  <markdown-docs path="help" />
</template>

<script>
import MarkdownDocs from '@/components/MarkdownDocs.vue'

export default {
  title: 'privacy',
  components: {
    MarkdownDocs,
  },
  data: () => ({}),
}
</script>
